import "../../App.scss";
import  "../../assets/css/libraries.css";
import  "../../assets/css/style.css";
import styled from "styled-components";
import {Helmet} from "react-helmet";



const AbdmServices = ({ type,setSearchText }) => {


    return (
        <div className="row">
            {/* {/* <!-- Post Item #1  --> */}
            <div className="col-sm-12 col-md-12 col-lg-12">
                {/* <!-- ========================
      page title 
  =========================== --> */}
                <section className="page-title page-title-layout5">
                    <div className="bg-img"><img src="assets/images/backgrounds/6.jpg" alt="background"/></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-between flex-wrap align-items-center">
                                <div><img src="assets/images/abdm/abdm_01.jpeg" alt="background1"/></div>
                                <div><img src="assets/images/abdm/abdm_02.jpg" alt="background1"/></div>
                                <div><img src="assets/images/abdm/abdm_03.jpg" alt="background1"/></div>
                                <div><img src="assets/images/abdm/abdm_04.jpg" alt="background1"/></div>
                                <div><img src="assets/images/abdm/abdm_05.jpg" alt="background1"/></div>


                               {/* <h1 className="pagetitle__heading my-3">This Page is Under Construction</h1>*/}

                            </div>{/* <!-- /.col-12 --> */}
                        </div>{/* <!-- /.row --> */}
                    </div>{/* <!-- /.container --> */}
                </section>{/* <!-- /.page-title --> */}

                {/* <!-- ======================
      FAQ
  ========================= --> */}

                <Helmet>
                    <script src="../../assets/js/jquery-3.5.1.min.js"></script>
                    <script src="../../assets/js/plugins.js"></script>
                    <script src="../../assets/js/main.js"></script>
                    <script src=
                                "https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"
                            type="text/javascript" />
                    <link rel="stylesheet"
                          href="https://fonts.googleapis.com/css2?family=Quicksand:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap"/>
                    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.3/css/all.css"/>

                    <link href="../../assets/images/logo/logo-light-small.png" rel="icon"/>
                </Helmet>
            </div>{/* {/* <!-- /.col-lg-4  --> */}
        </div>
    );
};

const Card = styled.div`
background-color: white;
border: 2px solid #d5d5d5;
padding: 0.5rem;
border-radius: 10px;
flex-grow: 1;
flex-basis: 46%;
h6 {
  text-align: center;
  font-size: 1rem;
  margin-block: 3%;
}
ul {
  padding-left: 10%;
}
a {
  padding-left: 10%;
  color: #651fff !important;
}
`;

export default AbdmServices;
